import { useNcsUserPreferencesQuery, useSetNcsUserPreferenceMutation } from 'src/api/api.generated'
import useErrorSnackBar from 'src/app/hooks/error-snack-bar/error-snack-bar'

export default function ConfigureNotificationCrud({ propertyId, tenantId, userId }: { propertyId: string; tenantId: string; userId: string | undefined }) {
  const showError = useErrorSnackBar()

  const { data: nscUserPreferencesData, loading: queryLoading } = useNcsUserPreferencesQuery({
    variables: {
      propertyId,
      tenantId,
      userId: userId ?? '',
    },
    skip: !userId,
    onError: showError,
  })

  const [setNcsUserPreference, { loading: mutationLoading }] = useSetNcsUserPreferenceMutation({
    onError: showError,
    refetchQueries: ['NcsUserPreferences'],
  })

  const nscUserPreferences = nscUserPreferencesData?.ncsUserPreferences?.templates ?? []

  return {
    nscUserPreferences,
    setNcsUserPreference,
    loading: queryLoading || mutationLoading,
  }
}
